export function isRequestAborted(error: unknown): boolean {
  if (!error || typeof error !== "object") {
    return false;
  }

  const hasAbortName = "name" in error && error.name === "AbortError";
  const hasAbortMessage =
    "message" in error &&
    typeof error.message === "string" &&
    error.message.toLowerCase().includes("aborted");
  const hasAbortError = "error" in error && error.error === "AbortError";

  return hasAbortName || hasAbortMessage || hasAbortError;
}
